import { Button } from 'modules/ui';
import styled from 'styled-components';

export const StyledBackButton = styled(Button)`
  margin-bottom: 2rem;
  margin-top: -1.2rem;
`;
